import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { disableSomeContentStyles, flexCenterMixin } from 'styles/mixins'
import Text from 'common-components/Text'

export const Panel = styled.div<{ $disabled?: boolean }>`
  flex: 1 0 40%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px dashed ${COLORS.secondarySemiLight};
  background-color: ${COLORS.primaryExtraLight};
  border-radius: 0.25rem;
  aspect-ratio: 1/1;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition:
    border-color 0.2s ease,
    opacity 0.2s ease;

  ${({ $disabled }) => $disabled && disableSomeContentStyles()}

  &:hover {
    border-color: ${COLORS.primaryDark};
  }
`

export const PanelLabel = styled(Text)`
  user-select: none;
`

export const PanelSubLabel = styled(Text)`
  user-select: none;
  position: absolute;
  bottom: 50%;
  left: 50%;
  transform: translate(-50%, 350%);
`

export const IconWrapper = styled.div`
  ${flexCenterMixin()}
  color: ${COLORS.secondarySemiDark};

  & > svg {
    width: 24px;
    height: 24px;

    path {
      fill: ${COLORS.secondarySemiDark};
    }
  }
`
